export default class TitleCta {
  constructor(el) {
    this.el = el
    this.init()
  }

  init() {}
}
